module.exports = __webpack_public_path__ + "img/image-home.d1e3b80a.jpg";